/**
 * Z-Index Constants
 * 
 * Centralized z-index values for consistent layering across the application.
 * This prevents z-index conflicts and makes it easy to understand the stacking context.
 */

export const Z_INDEX = {
  BASE: 0,
  SIDEBAR_DESKTOP: 10,
  SIDEBAR_MOBILE_OVERLAY: 40,
  SIDEBAR_MOBILE: 50,
  PAGE_CONTROLS: 100,          // Page-level navigation and controls
  PAGE_DROPDOWNS: 150,         // Dropdowns within page content
  FLOATING_CONTROLS: 1000,     // Global floating controls (always on top)
  FLOATING_DROPDOWNS: 5000,
  MODAL_BACKDROP: 50000,       // Modal backdrop - higher than all page elements
  MODAL_CONTENT: 50001,        // Modal content - above backdrop
  MODAL_PICKERS: 50002,        // Emoji pickers and dropdowns inside modals
} as const;

type ZIndexKey = keyof typeof Z_INDEX;